import { put, takeEvery } from "redux-saga/effects";

import { addNotification, loading } from "layouts/AppLayout/modules";
import { getApi } from "../../../sagas";
import { EXPORT_APP, ExportAppAction, exportAppEnd } from "../actions";

export function* exportApp(action: ExportAppAction) {
    const { payload } = action;
    const { appId, platform } = payload;

    const api = getApi(payload);

    try {
        yield put(loading(true, action));
        // @ts-ignore yields generate implicit anys as of TS 4.2
        const result = yield api.exportApp(appId, { platform });
        yield put(addNotification(`${appId} successfully exported`));
        yield put(exportAppEnd(undefined, result));
    } catch (e) {
        yield put(addNotification(e.message));
        yield put(exportAppEnd(e));
    } finally {
        yield put(loading(false, action));
    }
}

export function* watchExportApp() {
    yield takeEvery(EXPORT_APP, exportApp);
}
